module.exports = __webpack_public_path__ + "media/images/easy-29451e08ecfa537efe764a1cf9469f87.png";